class RelatedArticlesCarousel {
  constructor() {
    this.sections = Array.from(document.querySelectorAll(".related-articles-box"));
    if (!this.sections.length) return;

    this.sections.forEach((section, index) => this.initSection(section, index));
  }

  initSection(section, sectionIndex) {
    const track = section.querySelector(".wp-block-post-template");
    if (!track) return;

    track.classList.add("related-articles-box__track");
    this.markCards(track);

    const controls = this.ensureControls(section, sectionIndex);
    if (!controls) return;

    const prevBtn = controls.querySelector(".related-articles-box__arrow--prev");
    const nextBtn = controls.querySelector(".related-articles-box__arrow--next");
    if (!prevBtn || !nextBtn) return;

    const getStep = () => {
      const firstCard = track.querySelector(".related-articles-box__card");
      if (!firstCard) return 320;
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || "0") || 0;
      return firstCard.getBoundingClientRect().width + gap;
    };

    const updateControls = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft >= maxScroll - 4;

      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
      prevBtn.setAttribute("aria-disabled", atStart ? "true" : "false");
      nextBtn.setAttribute("aria-disabled", atEnd ? "true" : "false");
    };

    prevBtn.addEventListener("click", () => {
      track.scrollBy({ left: -getStep(), behavior: "smooth" });
    });

    nextBtn.addEventListener("click", () => {
      track.scrollBy({ left: getStep(), behavior: "smooth" });
    });

    track.addEventListener("scroll", updateControls);
    window.addEventListener("resize", updateControls);
    updateControls();
  }

  markCards(track) {
    const cards = Array.from(track.children).filter((item) => item.nodeType === 1);
    cards.forEach((card) => {
      card.classList.add("related-articles-box__card");

      const image = card.querySelector(".wp-block-post-featured-image img");
      if (image) this.upgradeCardImageQuality(image);
    });
  }

  upgradeCardImageQuality(image) {
    const srcset = image.getAttribute("srcset");
    if (!srcset) return;

    const candidates = srcset
      .split(",")
      .map((entry) => {
        const parts = entry.trim().split(/\s+/);
        if (parts.length < 2) return null;
        const widthMatch = parts[1].match(/^(\d+)w$/);
        if (!widthMatch) return null;
        return { url: parts[0], width: Number(widthMatch[1]) };
      })
      .filter(Boolean);

    if (!candidates.length) return;

    const largest = candidates.reduce((prev, current) =>
      current.width > prev.width ? current : prev
    );

    image.setAttribute("sizes", "(max-width: 781px) 78vw, (max-width: 1200px) 44vw, 29vw");
    if (largest && largest.url) {
      image.setAttribute("src", largest.url);
    }
  }

  ensureControls(section, sectionIndex) {
    let controls = section.querySelector(".related-articles-box__controls");
    if (controls) return controls;

    controls = document.createElement("div");
    controls.className = "related-articles-box__controls";

    const prevBtn = document.createElement("button");
    prevBtn.type = "button";
    prevBtn.className = "related-articles-box__arrow related-articles-box__arrow--prev";
    prevBtn.setAttribute("aria-label", "Previous related articles");
    prevBtn.setAttribute("aria-controls", `related-articles-track-${sectionIndex + 1}`);
    prevBtn.innerHTML = "&#10094;";

    const nextBtn = document.createElement("button");
    nextBtn.type = "button";
    nextBtn.className = "related-articles-box__arrow related-articles-box__arrow--next";
    nextBtn.setAttribute("aria-label", "Next related articles");
    nextBtn.setAttribute("aria-controls", `related-articles-track-${sectionIndex + 1}`);
    nextBtn.innerHTML = "&#10095;";

    controls.append(prevBtn, nextBtn);

    const track = section.querySelector(".related-articles-box__track");
    if (track && !track.id) {
      track.id = `related-articles-track-${sectionIndex + 1}`;
    }

    const heading = section.querySelector(".wp-block-heading");
    if (heading && heading.parentNode) {
      heading.parentNode.insertBefore(controls, heading.nextSibling);
    } else {
      section.appendChild(controls);
    }

    return controls;
  }
}

export default RelatedArticlesCarousel;
